const {
  REACT_APP_PROTOCOL,
  REACT_APP_SERVER_ADDRESS,
  REACT_APP_SERVER_PORT,
} = process.env;
export default `${(REACT_APP_SERVER_ADDRESS || REACT_APP_SERVER_PORT) ? `${REACT_APP_PROTOCOL}://${REACT_APP_SERVER_ADDRESS}:${REACT_APP_SERVER_PORT}` : 'https://gqls.materialtrackr.com'}/public/images/`;


